import React from 'react';
import SmsAutoReplySettings from 'components/organisms/sms-autoreply-settings';

const SmsAutoReplySettingsPage = () => {
  return <SmsAutoReplySettings />;
};

export default SmsAutoReplySettingsPage;
